import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=42202098&"
import script from "./companies.vue?vue&type=script&lang=js&"
export * from "./companies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42202098')) {
      api.createRecord('42202098', component.options)
    } else {
      api.reload('42202098', component.options)
    }
    module.hot.accept("./companies.vue?vue&type=template&id=42202098&", function () {
      api.rerender('42202098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/companies.vue"
export default component.exports